import clsx from 'clsx';
import React from 'react';

import { useAppContext } from '../../contexts/AppContext';
import useServerSideRendering from '../../hooks/useServerSideRendering';
import { getImgxSrc } from '../../utils/images';
import Button from '../BaseUI/Button';
import { EventProp } from './TimeLine';

const VerticalTimePoint = ({ events }: { events: EventProp[] }) => {
  const hydrated = useServerSideRendering();
  const { env } = useAppContext();
  const firstEvent = events[0];
  const secondEvent = events[1];

  return (
    <>
      {hydrated && (
        <>
          <div className="flex">
            <VerticalTimePointEvent eventType="ti">
              {firstEvent.month} <span className="block sm:inline">{firstEvent.year}</span>
            </VerticalTimePointEvent>
            <img
              className="rotate-90 absolute -top-20 left-48"
              src={getImgxSrc({
                path: 'brand_campaign/pinRed.svg',
                isDevDependence: true,
                envContext: env,
              })}
              alt="TI Event"
            />
            <div className="absolute sm:top-[2rem] sm:left-112 sm:ml-24 top-56 left-12">
              <img
                className="max-w-[180px]"
                src={getImgxSrc({
                  path: firstEvent.logoPath,
                  isDevDependence: true,
                  envContext: env,
                })}
                alt="TI Logo"
              />
              <div className="w-full max-w-[260px] sm:max-w-[350px]">
                <Button
                  variant="link"
                  className="font-serif text-button-lg sm:text-[22px] sm:leading-8 underline leading-6 text-left tracking-normal"
                  href={firstEvent.articleLink}
                >
                  “{firstEvent.articleTitle}”
                </Button>
              </div>
            </div>
          </div>
          <div className="flex">
            <VerticalTimePointEvent eventType="competitor">
              {secondEvent.month} <span className="block sm:inline">{secondEvent.year}</span>
            </VerticalTimePointEvent>
            <img
              className="rotate-90 absolute bottom-40 sm:bottom-8 left-48"
              src={getImgxSrc({
                path: 'brand_campaign/pinGray.svg',
                isDevDependence: true,
                envContext: env,
              })}
              alt="None TI Event"
            />
          </div>
          <div className="absolute sm:top-[222px] sm:left-112 sm:ml-24 -bottom-8 sm:-bottom-8 left-12 h-[108px] sm:h-96">
            <img
              className="max-w-[150px]"
              src={getImgxSrc({
                path: secondEvent.logoPath,
                isDevDependence: true,
                envContext: env,
              })}
              alt="Competitor Logo"
            />
            <div className="w-full max-w-[260px] sm:max-w-[350px] text-body-sm sm:text-button-lg font-serif leading-6 sm:leading-6 sm:tracking-normal">
              “{secondEvent.articleTitle}”
            </div>
          </div>
        </>
      )}
    </>
  );
};

interface VerticalTimePointEventProps {
  eventType: 'ti' | 'competitor';
  children: React.ReactNode;
}

const VerticalTimePointEvent = ({ eventType, children }: VerticalTimePointEventProps) => {
  return (
    <div
      className={clsx(
        'absolute sm:-left-[9rem] sm:text-button-md sm:max-w-full text-right -left-56 font-bold text-[8px] uppercase w-40 sm:w-[128px]',
        {
          'sm:top-[2.7rem] top-36 text-pro-red': eventType === 'ti',
          'sm:bottom-[4.25rem] bottom-96': eventType === 'competitor',
        }
      )}
    >
      {children}
    </div>
  );
};

export default VerticalTimePoint;
